<template>
  <div>
    <Card>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'static_site_manage',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>
